(function () {
  function init(root) {
    if (root.dataset.bbbReady) return;
    root.dataset.bbbReady = '1';
    var S = window.bbbStrings || {};
    var hero = root.querySelector('[data-hero]');
    var dialog = root.querySelector('[data-dialog]');
    var zoomImg = root.querySelector('[data-zoom-image]');
    root.querySelectorAll('.thumbnail').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('.thumbnail').forEach(function (b) { b.classList.remove('selected'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('selected'); btn.setAttribute('aria-pressed', 'true');
        if (hero) { hero.removeAttribute('srcset'); hero.src = btn.dataset.photo; hero.alt = btn.dataset.alt || ''; }
        if (zoomImg) { zoomImg.removeAttribute('srcset'); zoomImg.src = btn.dataset.photo; zoomImg.alt = btn.dataset.alt || ''; }
      });
    });
    var open = root.querySelector('[data-zoom-open]');
    var close = root.querySelector('[data-zoom-close]');
    if (open && dialog && dialog.showModal) {
      open.addEventListener('click', function () { dialog.showModal(); });
      close && close.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }
    var form = root.querySelector('[data-bbb-form]');
    if (!form) return;
    var input = form.querySelector('[data-variant-input]');
    var stock = root.querySelector('[data-stock]');
    var price = root.querySelector('[data-price]');
    var buy = form.querySelector('[data-buy]');
    var buyLabel = form.querySelector('[data-buy-label]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('.sizes button'));
    var chosen = buttons.length <= 1;
    if (chosen) root.classList.add('bbb-chosen');
    function render(btn) {
      if (!btn) return;
      input.value = btn.dataset.variant;
      var currency = price.querySelector('span');
      price.innerHTML = btn.dataset.price + ' ';
      if (currency) price.appendChild(currency);
      var qty = parseInt(btn.dataset.qty, 10);
      var available = btn.dataset.available === 'true';
      var msg;
      if (!available) msg = (S.soldOut || 'Sold out') + ' · ' + btn.dataset.size;
      else if (qty > 0) msg = (S.available || '[qty] available in [option]').replace('[qty]', qty).replace('[option]', btn.dataset.size);
      else msg = btn.dataset.size;
      stock.innerHTML = '<span class="dot"></span> ' + msg.replace(/</g, '&lt;');
      buy.disabled = !available;
      if (buyLabel) buyLabel.textContent = available ? (S.add || 'Add to cart') : (S.soldOut || 'Sold out');
    }
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        chosen = true;
        root.classList.add('bbb-chosen');
        render(btn);
      });
    });
    if (buttons.length === 1 && buttons[0].dataset.available === 'true') render(buttons[0]);
    form.addEventListener('submit', function (e) {
      if (!chosen) {
        e.preventDefault();
        stock.innerHTML = '<span class="dot"></span> ' + (S.choose || 'Please choose a size first');
        if (buttons[0]) buttons[0].focus();
      }
    });
  }
  function boot() { document.querySelectorAll('[data-bbb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();